import { CustomScrollbarService } from './../../shared/custom-scrollbar/custom-scrollbar.service';
import { DataEntry } from './../../shared/data-entry.interface';
import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { WebcallsService } from 'src/app/webcalls.service';
import { CommonService } from '../common.service';
import { DataproviderService } from 'src/app/dataprovider.service';
import { ActivatedRoute, Router, ChildrenOutletContexts } from '@angular/router';
import { ProgressiveBarService } from 'src/app/shared/progressive-bar/progressive-bar.service';
import { TooltipTypesEnum } from './../../shared/tooltip-types.enum';

@Component({
  selector: 'app-having-living-light',
  templateUrl: './having-living-light.component.html',
  styleUrls: ['./having-living-light.component.scss', './having-living-light.component.responsive.scss','../lateral-series.scss'],
  host: {
    class: 'center-route-content d-block bg-standard'
  }
})
export class HavingLivingLightComponent implements OnInit {
  title: string = "b2c.IDS_HAVINGLL";
  subtitle: string = "b2c.IDS_HAVINGLL_SUB";
  showSubtitle: boolean = false;
  subtitleInfo: string = "b2c.IDS_HAVINGLL_GUIDE";
  showSubtitleInfo: boolean = true;
  question: string = "b2c.IDS_HAVINGLL_QUE";
  activePage: string = "havingbticino";
  nextPage: string = "rooms";
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "IDS_HAVINGLL_LABEL";
  tooltipType: TooltipTypesEnum = TooltipTypesEnum.DISCOVER;

  dataEntries: DataEntry[] = [
  ];

  showSidebar: boolean = false;

  iDontKnowDataEntrie: DataEntry =
    {
      ID: -1,
      name:"b2c.IDS_DONTKNOW",
      name_ref: "dontknow",
      description: "",
      tooltip: "",
      image: "../../assets/img/btns/dontknow.png",
      //imageClassFromFrontEnd: "dontll",
      checked: false,
      lateralPanelId: "dontll-lateral"
    };
  constructor(
    private ro: Router,
    private cs: CommonService,
    private ws: WebcallsService,
    private ds: DataproviderService,
    public csbs: CustomScrollbarService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.cs.setParams(
      this.title,
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      false,
      true,
      false,
      true,
      null,
      false,
      false,
      this.eventCategory,
      this.eventLabel,
      false,
      null,
      true,
      this.showSubtitle,
      this.showSubtitleInfo,
      '',
      this.subtitleInfo
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(2);
  }

  ngOnInit() {
    this.cs.setEventAction(undefined);
    if (this.ds.getPossibleFinishings().length > 0){
      this.setDataEntries(this.ds.getPossibleFinishings());
    } else{
      this.wsCall();
    }

  }

  wsCall(){
    this.ws.getFinishing(this.ds.getLocalizationID(), this.ds.getTechnologyID()/*, this.ds.getSelectedPlugs()*/).subscribe( data => {
      this.setDataEntries(data);
    });
  }

  setDataEntries(data: {}){
    if (Array.isArray(data)){
      data.forEach(fin => {
        let finEntry: DataEntry = {
          ID: fin["ID"],
          name: fin.Nome,
          name_ref: fin.Nome_ref,
          description: fin.Description,
          image: "../../assets/img/btns/finishing-" + fin.Nome_ref + ".png",
          tooltip: fin.ReportDescription,
          lateralPanelId: "",
          checked: false
        };
        this.dataEntries.push(finEntry);
      });
      const filteredFin = this.dataEntries.filter(fin => fin.ID !== 5);
      this.dataEntries = filteredFin;
      this.dataEntries.push(this.iDontKnowDataEntrie);
      this.initSelection();
    }

  }

  initSelection() {
    let selectedData = this.ds.getFinishing();
    if (selectedData) {
      let finDataEntry = this.dataEntries.find(f => f.ID === selectedData.ID);
      if (finDataEntry) {
        this.dataEntriesUpdate(finDataEntry.ID);
        this.ds.setFinishing(finDataEntry);
        // this.onFinishingSelected(finDataEntry.ID, false);
      } else {
        // this.onFinishingSelected(null, true);
      }
    }
    // let selectedDataEntry = this.ds.getHavingLivingLigth();
    // if (selectedDataEntry) {
    //   this.onSelectorClicked(selectedDataEntry.ID);
    // }
  }

  dataEntriesUpdate(idSelected: number){
    /* single selection */
    for (let data of this.dataEntries) {
      if ( data.ID == idSelected ) { data.checked = true; } else { data.checked = false; }
    }
    this.cs.updateNextBtn(true);
  }

  onSelectorClicked(idSelected: number){
    let dataEntry: DataEntry = this.dataEntries.find(d => { return d.ID == idSelected });
    if (dataEntry) {
      this.dataEntriesUpdate(idSelected);
      this.ds.setHavingBTicino(dataEntry);
      this.ds.setFinishing(dataEntry);
    }

    let listChooise: [{ key: string; value: number; }];
    listChooise = this.cs.getOtherInfoFromSelector(this.dataEntries,idSelected,'STEP_0SERIE_');
    this.cs.setGASelectionEvent('step_0_serie',listChooise);
  }


  onCloseTooltip() {
    this.showSidebar = false;
  }
}
